// Framework and third-party non-UI
import React, { createContext, useMemo } from 'react';

// Redux, contexts, and local helpers/utils/modules
import { DataGridProps } from './types';

// Component specific modules (Component-styled, etc.)
import { StyledDataGrid } from './DataGrid-styled';

// App components

// Third-party components (buttons, icons, etc.)

export const DataGridContext = createContext<DataGridProps>({
  noTable: undefined,
  noCol: undefined,
  noRow: undefined
});

const DataGrid: React.FC<DataGridProps> = ({
  children,
  noTable,
  noCol,
  noRow,
  ...other
}) => {
  const dataGridState = useMemo(
    () => ({
      noTable,
      noCol,
      noRow
    }),
    [noCol, noRow, noTable]
  );

  return (
    <DataGridContext.Provider value={dataGridState}>
      <StyledDataGrid noCol={noCol} noRow={noRow} noTable={noTable} {...other}>
        {children}
      </StyledDataGrid>
    </DataGridContext.Provider>
  );
};

export default DataGrid;
